// extracted by mini-css-extract-plugin
export default {"napsa-header":"NapsaReport_napsa-header__hExlD","divider":"NapsaReport_divider__bG5At"};